<template>
  <div>
    <PlayerRegistrationFormPaymentConfirmationCard
      :authorizePayPalPayment="handleAuthorizePayPalPayment"
    />
    <v-form
      v-model="isPaymentMethodFormValid"
      ref="paymentForm"
      @submit.prevent="handleCompleteRegistration"
    >
      <PlayerRegistrationFormPaymentMethodCard
        :isCompleteRegistrationTriggerActive="
          isCompleteRegistrationTriggerActive
        "
        :changeDataFieldValue="handleChangeDataFieldValue"
        :moveToFormStep="moveToFormStep"
      />

      <div class="d-flex justify-space-between align-center my-10">
        <button
          type="button"
          class="primary--text"
          @click="moveToFormStep && moveToFormStep(1)"
        >
          <v-icon color="primary">mdi-chevron-left</v-icon>
          {{ $t("player_registration.back_to_registration") }}
        </button>
        <CommonButton
          v-if="
            playerRegistrationSummary.paymentMethod !==
              paymentProviderTypes.PAYPAL &&
              playerRegistrationSummary.paymentMethod !==
                paymentProviderTypes.FLUIDPAY
          "
          :label="
            playerRegistrationSummary.paymentMethod
              ? $t('player_registration.pay_now_and_complete_registration')
              : $t('player_registration.save_and_complete_registration')
          "
          color="secondary"
          notCapitalize
          height="50"
          @handleClick="handleCompleteRegistration"
          :loading="isCompleteRegistrationLoading"
        />
      </div>
    </v-form>
  </div>
</template>

<script>
import PlayerRegistrationFormPaymentConfirmationCard from "./PlayerRegistrationFormPaymentConfirmationCard";
import CommonButton from "../common/CommonButton";
import PlayerRegistrationFormPaymentMethodCard from "./PlayerRegistrationFormPaymentMethodCard";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { mapActions, mapGetters } from "vuex";
import { PaymentProvidersTypes } from "../enums/PaymentProvidersTypes";

export default {
  name: "PlayerRegistrationFormPaymentDetails",
  components: {
    PlayerRegistrationFormPaymentConfirmationCard,
    PlayerRegistrationFormPaymentMethodCard,
    CommonButton
  },
  props: {
    moveToFormStep: {
      type: Function,
      required: true
    }
  },
  data: () => ({
    isPaymentMethodFormValid: false,
    isCompleteRegistrationTriggerActive: false,
    isCompleteRegistrationLoading: false
  }),
  mounted() {
    this.isCompleteRegistrationTriggerActive = false;
    this.fetchPlayerRegistrationSummary({
      registrationPlayerId: this.registrationPlayerId
    });
  },

  computed: {
    paymentProviderTypes() {
      return PaymentProvidersTypes;
    },
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, [
      "playerRegistration",
      "playerRegistrationSummary",
      "registrationPlayerId"
    ])
  },

  methods: {
    ...mapActions(ModuleTypes.PLAYER_REGISTRATION, [
      "fetchPlayerRegistrationSummary",
      "finalizePaymentRegistration",
      "authorizePayPalPayment"
    ]),
    handleChangeDataFieldValue(fieldKey, value) {
      this[fieldKey] = value;
    },

    handleCompleteRegistration() {
      if (
        this.playerRegistrationSummary.paymentMethod ===
        PaymentProvidersTypes.STRIPE
      ) {
        this.$refs.paymentForm.validate();
        if (this.isPaymentMethodFormValid) {
          this.isCompleteRegistrationLoading = true;
          this.isCompleteRegistrationTriggerActive = true;
        }
      } else {
        this.isCompleteRegistrationLoading = true;
        this.finalizePaymentRegistration({
          successCallback: async () => {
            if (
              (this.playerRegistrationSummary.paymentMethod !==
                PaymentProvidersTypes.STRIPE &&
                this.playerRegistrationSummary.paymentMethod !==
                  PaymentProvidersTypes.PAYPAL &&
                this.playerRegistrationSummary.subTotal > 0) ||
              (this.playerRegistrationSummary.subTotal === 0 &&
                this.playerRegistrationSummary.promoCodeDiscount > 0)
            ) {
              const req = {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json"
                },
                method: "POST"
              };
              const fee = await fetch(
                `/rest-api/registration/second-step/${this.registrationPlayerId}/create-player-fee`,
                req
              ).then(res => res.json);
              console.log(fee);
            }
            this.moveToFormStep(3);
            this.isCompleteRegistrationLoading = false;
          }
        });
      }
    },
    handleAuthorizePayPalPayment() {
      if (
        this.playerRegistrationSummary.paymentMethod ===
        PaymentProvidersTypes.PAYPAL
      ) {
        this.authorizePayPalPayment();
      }
    }
  }
};
</script>

<style scoped></style>
